import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo } from 'react';

import { LazyRenderedComponent } from '../../lazy-rendered-component/lazy-rendered-component';

import './carousel-slide.scss';

const CarouselSlideUI = ({ children, className, isPrerendered, isAutoWidth, ...rest }) => (
  <swiper-slide class={clsx(className, 'sb-CarouselSlide', isAutoWidth && 'isAutoWidth')} {...rest}>
    {isPrerendered ? children : <LazyRenderedComponent>{children}</LazyRenderedComponent>}
  </swiper-slide>
);

CarouselSlideUI.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  className: PropTypes.string,
  isAutoWidth: PropTypes.bool,
  isPrerendered: PropTypes.bool,
};

CarouselSlideUI.defaultProps = {
  className: undefined,
  isAutoWidth: false,
  isPrerendered: false,
};

export const CarouselSlide = memo(CarouselSlideUI);
